import Reflux from 'reflux';
import ServerTimeActions from 'flux/actions/ServerTimeActions';
import BaseMixin from 'flux/stores/BaseMixin';

export default Reflux.createStore({
  listenables: [ServerTimeActions],

  mixins: [BaseMixin],

  init() {
    this.setState(new Date().getTime());
  },

  onSyncServerTime(time) {
    this.setStateAndTrigger(time);
  },
});
